import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

type StateWithProductPackages = { productPackages: FilterState };

const productPackages = createSlice({
    name: 'productPackages',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default productPackages.reducer;
export const { addNewFilter, removeFilter, clearFilters } = productPackages.actions;
export const selectFilters = (state: StateWithProductPackages) => state.productPackages.filters;
